import { render, staticRenderFns } from "./ForumPollMatrix.vue?vue&type=template&id=7d025d6c&scoped=true"
import script from "./ForumPollMatrix.vue?vue&type=script&lang=js"
export * from "./ForumPollMatrix.vue?vue&type=script&lang=js"
import style0 from "./ForumPollMatrix.vue?vue&type=style&index=0&id=7d025d6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d025d6c",
  null
  
)

export default component.exports